import { useBack } from "../http";
import { FormDTO } from "../types/FormDTO";

export class FormService {
	constructor() {}
	axiosInstance = useBack();

	async create(form: FormDTO) {
		try {
			const response = await this.axiosInstance.post('/form', form);
			return { ...response };
		} catch (error) {
			console.log(`Não foi possível criar o formulário`, error);
			return undefined;
		}
	}

	async listAll() {
		try {
			const response = await this.axiosInstance.get<FormDTO[]>('/form');
			return { ...response };
		} catch (error) {
			console.log(`Não foi possível obter os formulários`, error);
			return undefined;
		}
	}

	async conclude(id: number) {
		try {
			if (!id) return;
			const response = await this.axiosInstance.post(`/form/${id}/conclude`);
			return { ...response };
		} catch (error) {
			console.log(`Não foi possível concluir o formulário id ${id}: `, error);
			return undefined;
		}
	}

	async downloadResult(id: number) {
		return this.axiosInstance.get(`/form/${id}/result`, {
			responseType: "blob",
		});
	}

	async downloadRisks(id: number) {
		return this.axiosInstance.get(`/form/${id}/result/grade`, {
			responseType: "blob",
		});
	}

	async downloadInventary(id: number) {
		const response = await this.axiosInstance.get(`/form/${id}/result/inventario`);
		return {...response};
	}

	async getAvailableDownloads() {
		try {
			const response = await this.axiosInstance.get<string[]>(`/form/downloads`);
			return { ...response };
		} catch (error) {
			console.log(`Não foi possível obter os downloads disponíveis`, error);
			return undefined;
		}
	}

	async downloadFile(filename: string) {
		const body = { name: filename };
		return this.axiosInstance.post(`/form/download`, body, {
			responseType: "blob",
		});
	}

	async downloadModel() {
		return this.axiosInstance.get(`/form/answers-model`, {
			responseType: "blob",
		});
	}

	async importAnswers(id: number | undefined, uploadedFile: FormData | null) {
		const response = await this.axiosInstance.post(`/form/${id}/import-answers`, uploadedFile, {
			headers: {
				'Content-Type': 'multipart/form-data',
			},
		});
		return { ...response };
	}
}